export const categories = [
  {
    slug: 'mama-yu-guimi',
    name: '妈妈与闺蜜',
    description: '妈妈和闺蜜之间的故事，那些跨越岁月的深情厚谊',
    icon: 'ri-hearts-line',
    count: 12,
  },
  {
    slug: 'shenghuo-zhihui',
    name: '生活智慧',
    description: '妈妈们用一生积累的生活哲学与持家之道',
    icon: 'ri-lightbulb-line',
    count: 9,
  },
  {
    slug: 'suiyue-gushi',
    name: '岁月故事',
    description: '时光流转中，那些难忘的青春记忆与成长历程',
    icon: 'ri-book-open-line',
    count: 10,
  },
  {
    slug: 'qinggan-gongming',
    name: '情感共鸣',
    description: '直击心灵的情感瞬间，让无数人感同身受',
    icon: 'ri-emotion-line',
    count: 8,
  },
  {
    slug: 'rensheng-ganwu',
    name: '人生感悟',
    description: '妈妈们走过半生后的深刻感悟与生命启示',
    icon: 'ri-compasses-line',
    count: 7,
  },
];

export type Category = typeof categories[number];